import React from 'react'

export default props => (
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><title>Artboard 2v2asdf</title><polygon points="168.01 149.61 235.66 454.05 0.41 46.5 404.09 46.5 168.01 149.61"/><polygon points="500 47.8 270.1 400.99 216.7 162.89 293.43 210.11 500 47.8"/></svg>
)



// WEBPACK FOOTER //
// ./src/App/Menu/MenuHome/cv-icon-svg.js